import './MarkText.sass';

import Vue from 'vue';
import mixins from '@/utils/mixins';
import { VNode } from 'vue/types/umd';
import { getSlot } from '@/utils/helpers';

export default mixins(Vue).extend({
  name: 'mark-text',

  props: {
    tag: {
      type: String,
      default: 'a'
    },
    href: {
      type: String
    },
    icon: {
      type: [Boolean, String],
      default: false
    }
  },
  data: () => ({
    hover: false
  }),
  computed: {
    classes(): object {
      return {
        goto: true,
        'd-inline-flex': true
      };
    },
    styles(): object {
      return {};
    }
  },
  methods: {
    genIcon(): VNode | null {
      if (this.hover) {
        return this.$createElement(
          'v-icon',
          {
            props: {
              color: 'primary'
            }
          },
          [this.icon]
        );
      } else {
        return null;
      }
    },
    genFadeTransition(): VNode | null {
      return this.$createElement(
        'v-fade-transition',
        {
          props: {
            'hide-on-leave': true
          }
        },
        [this.genButton()]
      );
    },
    genButton(): VNode {
      return this.$createElement(
        'v-btn',
        {
          props: {
            text: true,
            color: 'primary',
            icon: true
          },
          class: 'pa-0 my-0 ml-2',

          on: { click: () => this.$emit('click:button') }
        },
        [getSlot(this, 'append') || this.genIcon()]
      );
    },
    genHover(): VNode {
      return this.$createElement(
        'v-hover',
        {
          class: 'pa-0 ma-0',

          domProps: {
            value: this.hover
          },
          on: {
            input: (event: any) => {
              this.hover = event;
              // this.$emit('hover', event);
            }
          }
        },
        [
          this.$createElement(
            'v-row',
            {
              props: {
                align: 'center',
                justify: 'start',
                'no-gutters': true
              },
              class: 'pa-0 ma-0'
            },
            [this.$slots.default, this.genFadeTransition()]
          )
        ]
      );
    }
  },
  render(h): VNode {
    const data = {
      attrs: {
        ...this.$attrs,
        href: this.href
      },
      class: this.classes,
      style: this.styles,
      on: {
        ...this.$listeners,
        click: () => {
          this.$emit('click'), console.log('hello');
        }
      }
    };
    const children = [this.genHover()] as (VNode | VNode[] | null)[];
    return h(this.tag, data, children);
  }
});
